<template>
  <div v-if="image"
       style="position: fixed; width: 100vw; height: 100vh; left: 0; top: 0; z-index: 9999999; background: rgba(33,33,33,.75)">
    <button type="button"
            class="bg-light-blue"
            style="position: absolute; right: 15px; top: 50px; z-index: 200; width: 35px; height: 35px; font-size: larger; margin-top: 0;"
            @click="$emit('hide')"
    >
      <span class="glyphicon glyphicon-resize-small"></span>
    </button>

    <pinch-image :src="image" :min-zoom="1" :max-zoom="3"></pinch-image>
  </div>
</template>

<script>
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";
import PinchImage from "./PinchImage";

export default {
  name: "PinchZoomOverlay",
  components: {PinchImage},
  props: {
    image: String,
  },
  watch: {
    image(newImage) {
      if (newImage) {
        document.body.classList.add('pinch-zoom-active')
        this.openInfoToast()
      } else {
        document.body.classList.remove('pinch-zoom-active')
      }
    }
  },
  methods: {
    openInfoToast() {
      Toastify({
        text: this._("Double tap or pinch with 2 fingers to zoom"),
        duration: 3000,
        close: false,
        gravity: "bottom", // `top` or `bottom`
        position: "center", // `left`, `center` or `right`
        backgroundColor: "rgba(0,0,0,.7)",
        stopOnFocus: true, // Prevents dismissing of toast on hover
      }).showToast();

    }

  }
}
</script>

<style scoped>

</style>
